import { baseApi } from './base'

// Import all API modules to ensure endpoints are injected
import './account-groups'
import './admin'
import './api-key'
import './auth'
import './charge'
import './chat-room'
import './consultation'
import './contract'
import './establishment'
import './expertise'
import './file'
import './form'
import './knowledge-base'
import './license'
import './medconnect-agent'
import './meeting-link'
import './network'
import './order'
import './patient'
import './planning'
import './policy'
import './recording'
import './report'
import './room'
import './schedule'
import './shift-marketplace'
import './speciality-option'
import './staff'
import './statistics'
import './super-admin'
import './time-tracking'
import './transcription'
import './waiting-room'

// Import the individual APIs for hook exports
import { accountGroupApi } from './account-groups'
import { adminApi } from './admin'
import { policyApi } from './policy'
import { apiKeyApi } from './api-key'
import { orderApi } from './order'
import { shiftMarketplaceApi } from './shift-marketplace'
import { medconnectAgentApi } from './medconnect-agent'
import { timeTrackingApi } from './time-tracking'

// The api is the baseApi with all injected endpoints
const api = {
  ...baseApi,
  endpoints: {
    ...baseApi.endpoints,
    ...accountGroupApi.endpoints,
    ...apiKeyApi.endpoints,
    ...shiftMarketplaceApi.endpoints,
    ...medconnectAgentApi.endpoints,
    ...adminApi.endpoints,
    ...policyApi.endpoints,
    ...orderApi.endpoints,
    ...shiftMarketplaceApi.endpoints,
    ...medconnectAgentApi.endpoints,
    ...medconnectAgentApi.endpoints,
    ...orderApi.endpoints,
    ...policyApi.endpoints,
    ...shiftMarketplaceApi.endpoints,
  },
}

export * from './medconnect-agent'

export const {
  useGetAccountGroupQuery,
  useGetAccountGroupsQuery,
  useCreateAccountGroupMutation,
  useUpdateAccountGroupMutation,
  useDeleteAccountGroupMutation,
  useDeleteAccountGroupsMutation,
} = accountGroupApi
export const { useGetApiKeyQuery, useGetApiKeysQuery, useCreateApiKeyMutation, useUpdateApiKeyMutation, useDeleteApiKeyMutation } = apiKeyApi
export const { useGetAvailableShiftsQuery, useClaimShiftMutation, useGetMyShiftsQuery, useReleaseShiftMutation } = shiftMarketplaceApi
export const {
  useGetTimeTrackingConsentQuery,
  useUpdateTimeTrackingConsentMutation,
  useStartTimeTrackingSessionMutation,
  useForceStartTimeTrackingSessionMutation,
  useStopTimeTrackingSessionMutation,
  useStopTimeTrackingBeaconMutation,
  useGetTimeTrackingSessionsQuery,
  useCreateTimeTrackingSessionMutation,
  useCorrectTimeTrackingSessionMutation,
  useGetTimeTrackingNotificationsQuery,
  useMarkTimeTrackingNotificationReadMutation,
  useGetTimeTrackingAuditLogsQuery,
  useGetTimeTrackingAdminStaffsQuery,
  useGetCurrentTimeTrackingSessionQuery,
} = timeTrackingApi

export default api
